export function clampText(text: string, maxCharacters: number, ellipsis = '...') {
  return text.length <= maxCharacters ? text : text.slice(0, maxCharacters) + ellipsis;
}

